export const deleteConfirmationParams = {
  titleText: 'Отвязать блогера',
  description: 'Вы действительно хотите отвязать блогера?',
  buttonWarmText: 'Отвязать',
}
